import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer-common',
    templateUrl: './footer-common.component.html',
    styleUrls: ['./footer-common.component.scss'],
    standalone: false
})
export class FooterCommonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
